import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPostcard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"postcard-2, address"} maskId="square-filled-radius-0-stroke-1-IconPostcard2"><path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM12 9V15H18V9H12ZM6 9.5V10.5L10 10.5V9.5H6ZM6 13.5L6 14.5L10 14.5V13.5L6 13.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPostcard2;
